import React, { Component } from 'react';
import ThumbNail from './ThumbNail';
import { requiredValidation } from './fieldValidateUtil';
import { getIn } from 'formik';
import { imageTypes, uploadFileOnServer } from '../../../../common/utils/fileUploadUtils';

class ImageUploadField extends Component {
  validate = (value) => {
    let error = requiredValidation(value, this.props.field);
    if (!error) {
    }
    console.log('Image :::' + error);
    return error;
  };

  checkMimeType = (event) => {
    let files = event.target.files;
    let err = '';
    for (var x = 0; x < files.length; x++) {
      if (imageTypes.every((type) => files[x].type !== type)) {
        err += files[x].type + ' is not a supported format\n';
      }
    }
    if (err !== '') {
      event.target.value = null;
      console.log(err);
      return false;
    }
    return true;
  };

  checkFileSize = (event) => {
    let files = event.target.files;
    let size = 15000;
    let err = '';
    for (var x = 0; x < files.length; x++) {
      if (files[x].size > size) {
        err += files[x].type + 'is too large, please pick a smaller file\n';
      }
    }
    if (err !== '') {
      event.target.value = null;
      console.log(err);
      return false;
    }

    return true;
  };

  uploadFile = (event) => {
    const { setFieldValue, field, collectionId, projectId, setSubmitting, version, plugins } =
      this.props;
    console.log('plugins ImageUploadField', plugins);
    setSubmitting(true);
    uploadFileOnServer(
      event,
      setFieldValue,
      field,
      collectionId,
      projectId,
      version,
      plugins,
      setSubmitting,
    );
  };

  render() {
    const { field, isConstructorForm, values } = this.props;
    const fieldValue = getIn(values, field.fieldName);
    return (
      <>
        <div className="">
          <input
            type={'file'}
            name={field.fieldName}
            className="form-control"
            onChange={this.uploadFile}
            required={!isConstructorForm && field.required}
          />
          <ThumbNail file={fieldValue} />
        </div>
      </>
    );
  }
}

export default ImageUploadField;
